import { render, staticRenderFns } from "./switch.vue?vue&type=template&id=6763075e&scoped=true"
import script from "./switch.vue?vue&type=script&lang=ts"
export * from "./switch.vue?vue&type=script&lang=ts"
import style0 from "./switch.vue?vue&type=style&index=0&id=6763075e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6763075e",
  null
  
)

export default component.exports